import { motion } from 'framer-motion';

// Resting-state aura for claimable reward cells. Pulses subtly so
// the eye is drawn to "things you can still do" without competing
// with the cell content itself.
//
// Two layered radial gradients, blurred, opacity-breathing on
// different cycles. Together they read as organic golden energy
// emanating from the reward, not a static highlight or a UI ring.
// No borders, no defined shapes, additively brightening via
// mix-blend-mode: screen so the underlying canvas texture stays
// visible through the glow.
//
// Sits behind the cell content (zIndex: -1) so the icon + text
// stay crisp on top of the warmth.
export default function ClaimableAura() {
  return (
    <>
      {/* Inner warmth. Small, brighter, faster cycle. Hugs the cell
          tight so the reward itself feels lit from within. */}
      <motion.div
        aria-hidden
        initial={{ opacity: 0.35 }}
        animate={{ opacity: [0.35, 0.85, 0.35] }}
        transition={{ duration: 2.2, repeat: Infinity, ease: 'easeInOut' }}
        style={{
          position: 'absolute',
          inset: '-0.6cqw',
          background:
            'radial-gradient(ellipse at center, rgba(255, 235, 175, 0.7) 0%, rgba(232, 196, 102, 0.4) 35%, rgba(180, 140, 60, 0.12) 60%, transparent 80%)',
          filter: 'blur(0.55cqw)',
          mixBlendMode: 'screen',
          pointerEvents: 'none',
          zIndex: -1,
          willChange: 'opacity',
        }}
      />
      {/* Outer breath. Larger, dimmer, slower cycle, offset phase.
          The two cycles drift in and out of sync, which keeps the
          glow from feeling like a mechanical pulse and gives the
          aura its "magical breath" character. */}
      <motion.div
        aria-hidden
        initial={{ opacity: 0.25 }}
        animate={{ opacity: [0.25, 0.55, 0.25] }}
        transition={{ duration: 3.4, repeat: Infinity, ease: 'easeInOut', delay: 0.6 }}
        style={{
          position: 'absolute',
          inset: '-1.6cqw',
          background:
            'radial-gradient(ellipse at center, rgba(255, 226, 142, 0.5) 0%, rgba(180, 140, 60, 0.22) 40%, transparent 75%)',
          filter: 'blur(1.2cqw)',
          mixBlendMode: 'screen',
          pointerEvents: 'none',
          zIndex: -1,
          willChange: 'opacity',
        }}
      />
    </>
  );
}
